export class CookieChangedCustomEvent extends CustomEvent<CookieChangedCustomEventDetail> {}

export interface CookieChangedCustomEventDetail {
  name: string;
  oldValue: string | null | undefined;
  newValue: string | null | undefined;
  status: "added" | "updated" | "deleted";
}
